import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/authSlice";
import { selectTotalUnread } from "../../redux/chatSlice";
import { destroySocket } from "../../services/chatSocket";

import homeIcon from "../../assets/images/icons/userTherapistPage/home.svg";
import discoverIcon from "../../assets/images/icons/userTherapistPage/discover.svg";
import therapyPlannerIcon from "../../assets/images/icons/userTherapistPage/therapyPlanner.svg";
import messagesIcon from "../../assets/images/icons/userTherapistPage/messages.svg";
import settingsIcon from "../../assets/images/icons/userTherapistPage/settings.svg";
import supportIcon from "../../assets/images/icons/userTherapistPage/support.svg";
import signOutIcon from "../../assets/images/icons/userTherapistPage/signOut.svg";


function UserSideBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const unreadTotal = useSelector(selectTotalUnread);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    destroySocket();
    dispatch(logoutUser());
    navigate("/signIn");
  };

  return (
    <div>
      {/* Sidebar */}
      <aside className="bg-background w-[155px] sm:w-[188px] md:w-[306px] mt-[5px] md:mt-[0px] rounded-[11px] md:rounded-[20px] pt-3 pl-3 md:pl-6 ml-2 md:ml-6 shadow-lg">
        <nav>
          <ul className="text-text">
            <div className="space-y-2 md:space-y-6 font-poppins text-[15px] md:text-[28px]">
              <li
                className={`flex items-center gap-2 cursor-pointer min-w-0 hover:text-text ${
                  isActive("/userHomePage") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/userHomePage")}
              >
                <img
                  src={homeIcon}
                  alt="Home"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                <span className="flex-1 whitespace-normal break-words leading-tight">
                  {t("home")}
                </span>
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer min-w-0 hover:text-text ${
                  isActive("/userPageDiscover") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/userPageDiscover")}
              >
                <img
                  src={discoverIcon}
                  alt="Discover"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                <span className="flex-1 whitespace-normal break-words leading-tight">
                  {t("discover")}
                </span>
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer min-w-0 hover:text-text ${
                  isActive("/userTherapyPlanner") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/userTherapyPlanner")}
              >
                <img
                  src={therapyPlannerIcon}
                  alt="Therapy Planner"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                <span className="flex-1 whitespace-normal break-words leading-tight">
                  {t("myCalendar")}
                </span>
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer min-w-0 hover:text-text ${
                  isActive("/userPageMessage") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/userPageMessage")}
              >
                <div className="relative shrink-0">
                  <img
                    src={messagesIcon}
                    alt="Messages"
                    className="md:w-6 md:h-6 w-4 h-4"
                  />
                  {unreadTotal > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] md:text-[10px] font-bold rounded-full min-w-[14px] md:min-w-[16px] h-[14px] md:h-[16px] flex items-center justify-center px-[3px] leading-none">
                      {unreadTotal > 99 ? "99+" : unreadTotal}
                    </span>
                  )}
                </div>
                <span className="flex-1 whitespace-normal break-words leading-tight">
                  {t("messages")}
                </span>
              </li>
            </div>
            <div className="pt-[23px] md:pt-[32px] space-y-2 md:space-y-6 font-poppins text-[15px] md:text-[28px]">
              <li
                className={`flex items-center gap-2 cursor-pointer min-w-0 hover:text-text ${
                  isActive("/userSettings") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/userSettings")}
              >
                <img
                  src={settingsIcon}
                  alt="Profile Settings"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                <span className="flex-1 whitespace-normal break-words leading-tight">
                  {t("settings")}
                </span>
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer min-w-0 hover:text-text ${
                  isActive("/userPageSupport") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/userPageSupport")}
              >
                <img
                  src={supportIcon}
                  alt="Support"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                <span className="flex-1 whitespace-normal break-words leading-tight">
                  {t("support")}
                </span>
              </li>
            </div>
            <button
              className="flex items-center gap-2 pt-[50px] md:pt-[100px] font-poppins text-[15px] md:text-[28px] hover:text-text cursor-pointer min-w-0"
              onClick={handleLogout}
            >
              <img
                src={signOutIcon}
                alt="Sign Out"
                className="md:w-6 md:h-6 w-4 h-4"
              />
              <span className="flex-1 whitespace-normal break-words leading-tight text-left">
                {t("signOut")}
              </span>
            </button>
          </ul>
        </nav>
      </aside>
    </div>
  );
}

export default UserSideBar;
